import store from "../../../store";
export const loggedEventTypes = {
  audit: "1"
};

export const operationTypes = {
  delete: "5",
  update: "3",
  read: "2",
  create: "1"
};

export const loggedEventSources = {
  default: "securebase_new"
};

const loggedInUser = () => {
  return store?.getState()?.auth?.auth?.user
    ? store.getState().auth.auth.user
    : "";
};

// description const
export const generateCustomerScheduleDesc = (customerId) =>
  `Operation - Customer Schedule - Generate Service Dates employee_id: ${
    loggedInUser().employee_id
  } Customer Id: ${customerId}.`;
export const generateCustomerLocationChangeDesc = (customerId) =>
  `Operation - Customer Information - Service Information - insert - update - customer location employee_id: ${
    loggedInUser().employee_id
  } Customer Id: ${customerId}.`;
export const generateCustomerOnHoleDesc = (customerId) =>
  `Operation - Customer Information - Service Information - customer on hold - employee_id: ${
    loggedInUser().employee_id
  } Customer Id: ${customerId}.`;
export const generateCustomerClosureDesc = (customerId) =>
  `Operation - Customer Information - Service Information - customer Closure - employee_id: ${
    loggedInUser().employee_id
  } Customer Id: ${customerId}.`;
export const insertNewScheduleDesc = (customerId) =>
  `Operation - Customer Information - Service Window - insert - customer Schedule employee_id: ${
    loggedInUser().employee_id
  } Customer Id: ${customerId}.`;

export const routeManagementDesc = (scheduleId) =>
  `Operation - Customer Schedule - Route Update employee_id: ${
    loggedInUser().employee_id
  } Customer Schedule Id: ${scheduleId}.`;

export const customerPreferenceUpdateDesc = (customerId) =>
  `Operation - customer information - update customer preference employee_id: ${
    loggedInUser().employee_id
  } Customer  Id: ${customerId}.`;
//authorization
export const customerDeleteDesc = (personnelId) =>
  `Administration - Authorization - Personal Details - delete -customer -in customer list - employee_id: ${
    loggedInUser().employee_id
  } Personnel Id: ${personnelId}.`;
export const customerPersonalDetailChangeDesc = (personnelId) =>
  `Administration - Authorization - Personal Details - insert - update - customer details - employee_id: ${
    loggedInUser().employee_id
  } Personnel Id: ${personnelId}.`;
export const customerDetailsSearchDesc = (personnelId) =>
  `Administration - Administration - Authorization - Personal Search - get details -  employee_id: ${
    loggedInUser().employee_id
  } Personnel Id: ${personnelId}.`;
export const CustomerDetailsUpdateDesc = (personnelId) =>
  `Administration - Authorization - Personal Details - update - employee_id: ${
    loggedInUser().employee_id
  } Personnel Id: ${personnelId}.`;

export const employeeDetailsInsertUpdateDesc = (employeeId) =>
  `Administration - Employee Detail - updated - by - employee_id: ${
    loggedInUser().employee_id
  }: employee_id: ${employeeId} - updated`;
//Transport
export const runCreateDesc = (runId) =>
  `Operation - Transportation - Run Management - insert - create run - employee_id: ${
    loggedInUser().employee_id
  } Run Id: ${runId}.`;
export const vendorCreateDesc = (vendorId) =>
  `Operation - Transportation - Vendor Management - insert - create vendor - employee_id: ${
    loggedInUser().employee_id
  } Vendor Id: ${vendorId}.`;
//Correctiveactionrequest
export const correctiveActionRequestCreateDesc = (requestId) =>
  `Operation - Corrective Action Request- Details - insert - Corrective Action - employee_id: ${
    loggedInUser().employee_id
  } Corrective Action Request Id: ${requestId}.`;
export const correctiveActionInvestigationUpdateDesc = (requestId) =>
  `Operation - Corrective Action Request- Details - update- Investigation - employee_id: ${
    loggedInUser().employee_id
  } Corrective Action Request Id: ${requestId}.`;
export const correctiveActionResolutionUpdateDesc = (requestId) =>
  `Operation - Corrective Action Request- Details - update- Resolution - employee_id: ${
    loggedInUser().employee_id
  } Corrective Action Request Id: ${requestId}.`;
//Customer Move
export const customerMoveUpdateDesc = (customerMoveProcessId) =>
  `Administration - Customer Move Details - insert - update - employee_id: ${
    loggedInUser().employee_id
  } Customer Move Process Id: ${customerMoveProcessId}.`;
//LogicalVault
export const logicalVaultShelvesUpdateDesc = () =>
  `Operation - Logical Vault Details- Shelf - update - employee_id: ${
    loggedInUser().employee_id
  }.`;
export const logicalVaultReleaseShelvesUpdateDesc = () =>
  `Operation-Logical Vault Details- Release - Shelf update - employee_id: ${
    loggedInUser().employee_id
  }.`;

// comment const

// description const
export const generateCustomerScheduleComment = (
  newEndDate,
  newStartDate,
  serviceFreq,
  mode,
  cslFlag
) =>
  `new_gen_date_end: ${newEndDate} - new_gen_date_start: ${newStartDate} - new_serv_freq_code: ${serviceFreq} - mode: ${mode} - csl_flag: ${cslFlag}`;
export const generateCustomerLocationChangeComment = (
  address,
  exchangeLocationTypeCode,
  cityName,
  stateProvince_id,
  zip,
  lastModUser,
  requiredNotificationDays
) =>
  `address: ${address} | exchange_location_type_code: ${exchangeLocationTypeCode} | city_name: ${cityName} | state_province_id: ${stateProvince_id} | zip: ${zip} | last_mod_user: ${lastModUser} | required_notification_days: ${requiredNotificationDays}.`;

export const insertNewSchedulePayload = (payload) => `Payload - ${payload}`;

export const routeManagementComment = (payload) => `Payload - ${payload}`;

export const customerPreferenceUpdateComment = (payload) =>
  `Payload - ${payload}`;

//authorization
export const customerDeleteComment = (
  customerIdList,
  personnelId,
  authBypassReason
) =>
  `Payload - customer_id_list: ${customerIdList} - personnel_id: ${personnelId} - auth_bypass_reason: ${authBypassReason}`;

export const customerPersonalDetailChangeComment = (payload) =>
  `Payload - ${payload}`;

export const CustomerDetailsUpdateComment = (payload) => `Payload - ${payload}`;

//Transport
export const runCreateComment = (payload) => `Payload - ${payload}`;
export const vendorCreateComment = (
  mainDistrictId,
  name,
  contactName,
  accountNumber,
  address,
  city,
  stateProvinceId,
  zip,
  localeId,
  businessPhone1,
  businessPhone2
) =>
  `Payload - main_district_id: ${mainDistrictId} - name: ${name} - contact_name: ${contactName} - account_number: ${accountNumber} - address: ${address} - city: ${city} - state_province_id: ${stateProvinceId} - zip: ${zip} - locale_id: ${localeId} - business_phone1: ${businessPhone1} - business_phone2: ${businessPhone2}`;

export const employeeDetailsInsertUpdateComment = (payload) =>
  `Payload - ${payload}`;
//Correctiveactionrequest
export const correctiveActionRequestCreateComment = (
  mainDistrictId,
  customerId,
  correctiveActionRequestTypeId,
  detectedDatetime,
  loggingEmployeeId,
  customerDisplayFlag,
  notifyAccountOwnerFlag,
  manualCreateFlag,
  billableFlag
) =>
  `Payload - main_district_id: ${mainDistrictId} - customer_id: ${customerId} - corrective_action_request_type_id: ${correctiveActionRequestTypeId} - detected_datetime: ${detectedDatetime} - logging_employee_id: ${loggingEmployeeId} - customer_display_flag: ${customerDisplayFlag} - notify_account_owner_flag: ${notifyAccountOwnerFlag} - manual_create_flag: ${manualCreateFlag} - billable_flag: ${billableFlag}`;
export const correctiveActionInvestigationUpdateComment = (payload) =>
  `Payload - ${payload}`;
export const correctiveActionResolutionUpdateComment = (payload) =>
  `Payload - ${payload}`;
//Customer Move
export const customerMoveUpdateComment = (payload) => `Payload - ${payload}`;
//LogicalVault
export const logicalVaultShelvesUpdateComment = (payload) =>
  `Payload - ${payload}`;
export const logicalVaultReleaseShelvesUpdateComment = (payload) =>
  `Payload - ${payload}`;
//#region Open Media

// Description Const
export const generatePickingProcessDesc = (paddedIds) =>
  `Operation - Open Media - Work Management - Picking - Batch/Combine - insert - update - employee_id: ${
    loggedInUser().employee_id
  } open_media_batch_id_list: ${paddedIds}`;

export const generateSkipVerifyDesc = (batchIds, logicalVaultId) =>
  `Operation - Open Media - Work Management - Picking - Skip Verify - employee_id: ${
    loggedInUser().employee_id
  } batch_list: ${batchIds} logical_vault_id: ${logicalVaultId}`;

export const generateVerifyDesc = (batchIds, logicalVaultId) =>
  `Operation - Open Media - Work Management - Picking -  Verify - employee_id: ${
    loggedInUser().employee_id
  } batch_list: ${batchIds} logical_vault_id: ${logicalVaultId}`;

export const generateInsertPossibleMatchesDesc = (OmAuditDetailId) =>
  `Operation - Open Media - OM Audit Details - insert Possible matches- employee_id: ${
    loggedInUser().employee_id
  } om_audit_detail_id: ${OmAuditDetailId}`;

export const generateCancelOmAudit = (OmAuditId) =>
  `Operation - Open Media - OM Audit Details - Cancel Audit - employee_id: ${
    loggedInUser().employee_id
  } om_audit_id: ${OmAuditId}`;

export const generateCreateOmAudit = (OmAuditId) =>
  `Operation - Open Media - OM Audit Details - Create Audit - employee_id: ${
    loggedInUser().employee_id
  } om_audit_id: ${OmAuditId}`;

export const generateUpdateOmAudit = (OmAuditId) =>
  `Operation - Open Media - OM Audit Details - Update Audit - employee_id: ${
    loggedInUser().employee_id
  } om_audit_id: ${OmAuditId}`;

export const generateOmAssignSlot = (onBatchIdList) =>
  `Operation - Open Media - Work Management - Distribution - Assign Slot - employee_id: ${
    loggedInUser().employee_id
  } open_media_batch_id_list: ${onBatchIdList}`;

// Comment Const
export const openMediaPickingComment = (payload) => `Payload - ${payload}`;

export const openMediaSkipVerifyComment = (payload) => `Payload - ${payload}`;

export const openMediaVerifyComment = (payload) => `Payload - ${payload}`;

export const openMediaInsertPossibleMatchesComment = (payload) =>
  `Payload - ${payload}`;

export const openMediaCancelOmAuditComment = (payload) =>
  `Payload - ${payload}`;

export const openMediaCreateAuditComment = (payload) => `Payload - ${payload}`;

export const openMediaUpdateAuditComment = (payload) => `Payload - ${payload}`;

export const openMediaAssignSlotComment = (payload) => `Payload - ${payload}`;

//#endregion

// vault configaration
export const generateDeleteVault = (vaultID) =>
  `Operation - vault configuration - Delete existing physical Vault employee_id: ${
    loggedInUser().employee_id
  } vault ID: ${vaultID}`;

export const generateDeleteRack = (rack) =>
  `Operation - vault configuration - Delete existing rack employee_id: ${
    loggedInUser().employee_id
  } rackID: ${rack}`;

export const generateDeleteRow = (row) =>
  `Operation - vault configuration - Delete existing raw employee_id: ${
    loggedInUser().employee_id
  } raw  ID: ${row}`;

export const generateDeleteShelf = (shelf) =>
  `Operation - vault configuration - Delete existing shelf employee_id: ${
    loggedInUser().employee_id
  } shelf ID: ${shelf}`;

//#region Container Processing
// Description
export const generateCPAuditCancelDesc = (containerAuditId) =>
  `Operation - Container Processing - Container audit details - Cancel - employee_id: ${
    loggedInUser().employee_id
  } container_audit_id: ${containerAuditId}`;

export const generateCPAuditUpdateDesc = (containerAuditId) =>
  `Operation - Container Processing - Container audit details - Update - employee_id: ${
    loggedInUser().employee_id
  } container_audit_id: ${containerAuditId}`;

export const generateCPAuditCreateDesc = (containerAuditId) =>
  `Operation - Container Processing - Container audit details - Create - employee_id: ${
    loggedInUser().employee_id
  } container_audit_id: ${containerAuditId}`;

export const generateCPPickingPrintDesc = (containerList, run) =>
  `Operation - Container Processing - General - Pick Print - employee_id: ${
    loggedInUser().employee_id
  } container: ${JSON.stringify(containerList)} run: ${JSON.stringify(run)}`;

export const generateCPPickingVerifytDesc = (containerList, run) =>
  `Operation - Container Processing - General - Verify - employee_id: ${
    loggedInUser().employee_id
  } container: ${JSON.stringify(containerList)} run: ${JSON.stringify(run)}`;

export const generateCPPickingRunDesc = (containerList, run) =>
  `Operation - Container Processing - General - Run Prep - Run - employee_id: ${
    loggedInUser().employee_id
  } container: ${JSON.stringify(containerList)} run: ${JSON.stringify(run)}`;

export const generateRunPositionUpdateDesc = (runPositionId) =>
  `Operation - Container Processing - General - Incomplete Stop - Run Position Update -  employee_id: ${
    loggedInUser().employee_id
  } run_position_id: ${runPositionId}`;

export const generateContainerUpdateDesc = (containerId) =>
  `Operation - Container Processing - Container Issurance - Issurance - Update - employee_id: ${
    loggedInUser().employee_id
  } container_id: ${containerId}`;

export const generatRequestUpdateDesc = (batchID) =>
  `Operation - Container Processing - Container Issurance - Issurance - Update Request - employee_id: ${
    loggedInUser().employee_id
  } batch_id: ${batchID}`;

export const generatRunStatusUpdateDesc = (runId) =>
  `Operation - Container Processing - Run Prep - Update Run Status - employee_id: ${
    loggedInUser().employee_id
  } run_id: ${runId}`;

// Comment
export const cPAuditCancelComment = (payload) => `Payload - ${payload}`;

export const cPAuditUpdateComment = (payload) => `Payload - ${payload}`;

export const cPAuditCreateComment = (payload) => `Payload - ${payload}`;

export const cPPickingPrintComment = (payload) => `Payload - ${payload}`;

export const cPPickingVerifyComment = (payload) => `Payload - ${payload}`;

export const cPPickingRunComment = (payload) => `Payload - ${payload}`;

export const cPRunPositionUpdateComment = (payload) => `Payload - ${payload}`;

export const cPContainerUpdateComment = (payload) => `Payload - ${payload}`;

export const cPRequestUpdateComment = (payload) => `Payload - ${payload}`;

export const cPRunStatusUpdateComment = (payload) => `Payload - ${payload}`;

//#endregion

//#region Discrepancy Management
// Description
export const generateDiscrepancyUpdateDesc = (discrepancyIdXML, type) =>
  `Operation - Discrepancy Management - Discrepancy Update - ${type} - Update - employee_id: ${
    loggedInUser().employee_id
  } discrepancy_id_last_mod_date_xml: ${discrepancyIdXML}`;

// Comment

export const discrepancyUpdateComment = (payload) => `Payload - ${payload}`;
//#endregion

// auto store
export const generateDescPickingPrintPickReport = (ids, report) =>
  `Work management -  picking - print pick report - employee_id: ${
    loggedInUser().employee_id
  } - open_media_batch_id_list: ${ids} - report: ${report}`;
export const generateDescDistributionPrintPickReport = (ids, report) =>
  `Work management -  Distribution  - print Distribution  - employee_id: ${
    loggedInUser().employee_id
  } - open_media_batch_id_list: ${ids} - report: ${report}`;
export const generateDestructionReportPrintDesc = (ids, report) =>
  `Request  -  Media Destruction Request - vault itemized - print pick report  - employee_id: ${
    loggedInUser().employee_id
  } - destruct_request_id: ${ids} - report: ${report}`;

// Billing
export const saveCapacityBillingConfigurationDesc = (pricing_contract_code) =>
  `Administration - Billing - Capacity Billing - Configuration Search - Capacity Billing - Configuration Detail - Update - employee_id: ${
    loggedInUser().employee_id
  } - pricing_contract_code: ${pricing_contract_code}`;
export const saveCapacityBillingConfigurationComment = (payload) =>
  `Payload - ${payload}`;
export const insertRecurringChargeDesc = (customer_id, catalog_item_code) =>
  `Administration - Billing - Recurring charge detail - Create Recurring Charge - Save - employee_id: ${
    loggedInUser().employee_id
  } - customer_id: ${customer_id} - catalog_item_code: ${catalog_item_code}`;
export const insertRecurringChargeComment = (payload) => `Payload - ${payload}`;
export const updateRecurringChargeDesc = (recurring_transaction_id) =>
  `Administration - Billing - Recurring charge search - Update Recurring Charge - Save - employee_id: ${
    loggedInUser().employee_id
  } - recurring_transaction_id: ${recurring_transaction_id}`;
export const updateRecurringChargeComment = (payload) => `Payload - ${payload}`;
export const bulkUpdateInterfaceTransDesc = (customer_id) =>
  `Administration - Billing - Billing Error Log - Update Error log - Update - employee_id: ${
    loggedInUser().employee_id
  } - customer_id: ${customer_id}`;
export const bulkUpdateInterfaceTransComment = (payload) =>
  `Payload - ${payload}`;
export const insertBillingRunPhaseDesc = (billing_cycle_code) =>
  `Administration - Billing - Billing Status - employee_id: ${
    loggedInUser().employee_id
  } - billing_cycle_code: ${billing_cycle_code}`;
export const insertBillingRunPhaseComment = (payload) => `Payload - ${payload}`;
export const billingResetPhase3okClickDesc = (billing_cycle_code) =>
  `Administration - Billing - Billing Status - Complete - Ok - employee_id: ${
    loggedInUser().employee_id
  } - billing_cycle_code: ${billing_cycle_code}`;
export const billingResetPhase3okClickComment = (payload) =>
  `Payload - ${payload}`;
export const billTrans2ByDistrictDesc = (bill_cycle_code) =>
  `Administration - Billing - Billing Transactions - Save - employee_id: ${
    loggedInUser().employee_id
  } - bill_cycle_code: ${bill_cycle_code}`;
export const billTrans2ByDistrictComment = (payload) => `Payload - ${payload}`;
export const insertInterfaceTransByDistrictDesc = (bill_cycle_code) =>
  `Administration - Billing - Billing Transactions - Save - employee_id: ${
    loggedInUser().employee_id
  } - bill_cycle_code: ${bill_cycle_code}`;
export const insertInterfaceTransByDistrictComment = (payload) =>
  `Payload - ${payload}`;
export const execInterfaceTransUpdateByDistrictDesc = (
  billing_transaction_id
) =>
  `Administration - Billing - Billing Transactions - Save - employee_id: ${
    loggedInUser().employee_id
  } - billing_transaction_id: ${billing_transaction_id}`;
export const execInterfaceTransUpdateByDistrictComment = (payload) =>
  `Payload - ${payload}`;

export const pickingPrintPickReportComment = (payload) =>
  `Payload - ${payload}`;
export const distributionPrintPickReportComment = (payload) =>
  `Payload - ${payload}`;
export const destructionPickReportComment = (payload) => `Payload - ${payload}`;

export const billingResetDesc = (districtID) =>
  `Administration - Billing - Billing Status - Reset - employee_id: ${
    loggedInUser().employee_id
  } - district_id: ${districtID}`;

export const billingResetComment = (payload) => `Payload - ${payload}`;

// dr event

export const generateDrEventInsertDesc = (ids) =>
  `Operation - Disaster Recovery -  event - insert DR event - employee_id: ${
    loggedInUser().employee_id
  } - DR event ID: ${ids}`;
export const generateDrEventUpdateDesc = (ids) =>
  `Operation - Disaster Recovery -  event - update DR event - employee_id: ${
    loggedInUser().employee_id
  } - DR event ID: ${ids}`;
export const generateDrEventRequestGenDesc = (ids) =>
  `Operation - Disaster Recovery -  event - request generation - employee_id: ${
    loggedInUser().employee_id
  } - DR event ID: ${ids}`;

export const generateDrEventInsertComment = (payload) => `payload: ${payload}`;
export const generateDrEventUpdateComment = (payload) => `payload: ${payload}`;
export const generateDrEventRequestGenComment = (payload) =>
  `payload: ${JSON.stringify(payload)}`;

// session handling
export const generateSessionInitDesc = (employeeId) =>
  `Login - app access -  employee_id: ${employeeId} `;

//#region Request
// Description
export const generateCreateNewDestructionRequestDesc = (
  customerID,
  volserList,
  isDelivery
) =>
  `Request - Media Destruction Request ${
    isDelivery ? "Delivery" : "Pickup"
  } - Request Insert - Insert - employee_id: ${
    loggedInUser().employee_id
  } customer_id: ${customerID} volser_list: ${volserList}`;

export const generateUpdateDestructionRequestDesc = (
  destructionRequestId,
  isDelivery
) =>
  `Request - Media Destruction Request ${
    isDelivery ? "Delivery" : "Pickup"
  } - Request Update - Update - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateCancelDestructionRequestDesc = (
  destructionRequestId,
  isDelivery
) =>
  `Request - Media Destruction Request ${
    isDelivery ? "Delivery" : "Pickup"
  } - Request Cancel - Cancel - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateUpdateFileRequestDesc = (requestId) =>
  `Request - Media Destruction Request Pickup - Update File - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateDeleteBoxTypeCountDesc = (destructionRequestId) =>
  `Request - Media Destruction Request Pickup - Delete Box Type Count - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateInsertBoxTypeCountDesc = (destructionRequestId) =>
  `Request - Media Destruction Request Pickup - Insert Box Type Count - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateInsertRequestCommentDesc = (destructionRequestId) =>
  `Request - Media Destruction Request Pickup - Insert Request Comments - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateDeleteRequestCommentDesc = (destructionRequestId) =>
  `Request - Media Destruction Request Pickup - Delete Request Comments - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateInsertRequestSpecialHandlingDesc = (
  destructionRequestId
) =>
  `Request - Media Destruction Request Picking - Insert Request Special Handling - employee_id: ${
    loggedInUser().employee_id
  } destruct_request_id: ${destructionRequestId}`;

export const generateRescheduleRequestUpdateDesc = (
  cslCustomerId,
  cslNewRequestId
) =>
  `Request - Reschedule Service - Reschedule Save - employee_id: ${
    loggedInUser().employee_id
  } cslNewRequestId: ${cslNewRequestId} cslCustomerId:${cslCustomerId}`;

export const generateAssignTransportToRequestDesc = (requestId) =>
  `Request - Media Request Detail - Assign Transport to Request - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateUpdateRequestDesc = (requestId) =>
  `Request - Media Request Details - Request Update - Update - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateGetRequestDesc = (requestId) =>
  `Request - Media Request Details - Find Request - Read - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateCancelRequestDesc = (requestId) =>
  `Request - Media Request Details - Request Cancel - Cancel - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateCancelRequestCheckDesc = (requestId) =>
  `Request - Media Request Details - Request Cancel Check - Read - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateGetBypassReason = (authenticationBypassId) =>
  `Request - Media Request Details - Get Bypass ID - Read - employee_id: ${
    loggedInUser().employee_id
  } authentication_bypass_id: ${authenticationBypassId}`;

export const generateCreateVaultItemizedRequestDesc = (
  customerId,
  volserList
) =>
  `Request - Media Destruction Request Detail - Vault Itemized - Insert - employee_id: ${
    loggedInUser().employee_id
  } customer_id: ${customerId} volser_list: ${volserList}`;

export const generateUpdateVaultItemizedRequestDesc = (requestId) =>
  `Request - Media Destruction Request Detail - Vault Itemized - Update - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

export const generateCancelVaultItemizedRequestDesc = (requestId) =>
  `Request - Media Destruction Request Detail - Vault Itemized - Cancel - employee_id: ${
    loggedInUser().employee_id
  } request_id: ${requestId}`;

// Comment
export const requestComment = (payload) => `Payload - ${payload}`;
//#endregion
